<template>
  <div class="width-100 flex-column align-items-center justify-content-start">
    <div class="width-100 head_bg">
      <div class="custom-width">
        <el-image width="254px" :src="require('../../../assets/image/supplier/pc/logo.png')"></el-image>
        <div class="width-100 white textAlign-c margin-t fw-bold" style="font-size: 38px; letter-spacing: 8px">供应商查询</div>
        <div class="width-100 white textAlign-c fs-20 margin-ts fls-2">自助查询库内供应商信息</div>
        <div class="width-95 flex-row justify-content-spaceBetween br-big bg-white" style="margin: 25px auto 0; padding: 2px 2px">
          <div class="width-20">
            <el-select class="width-100" v-model="searchData.companyType" filterable placeholder="类目">
              <el-option v-for="item in companyTypeList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"> </el-option>
            </el-select>
          </div>
          <div class="width-70">
            <input
              class="width-100"
              v-model="searchData.searchValue"
              style="border: 0; outline: none; height: 32px; line-height: 32px"
              placeholder="搜索供应商名称或营业范围"
            />
          </div>
          <div class="width-8 br-big white textAlign-c" style="background-color: #3274f2; line-height: 32px" @click="searchChange">搜索</div>
        </div>
      </div>
    </div>
    <el-table :data="supplierList" class="custom-width border" @row-click="jumpToDetail">
      <el-table-column prop="companyName" label="供应商名称" width="240"> </el-table-column>
      <el-table-column prop="contactsPhone" label="联系电话" width="140"> </el-table-column>
      <el-table-column prop="companyAddress" label="地址"> </el-table-column>
      <el-table-column label="供应商类型">
        <template slot-scope="scope">
          <div class="width-100">
            <span
              style="padding: 2px 10px; background: #ecf1ff; color: #4c7dff"
              class="br-big fs-sml margin-rs margin-bs"
              v-for="(its, index) in scope.row.companyTypeArr"
              :key="index"
            >
              {{ its }}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="searchData.pageNum" :limit.sync="searchData.pageSize" @pagination="getList" />
  </div>
</template>

<script>
import { getDictDetail } from '@/api/commonApi';
import * as dd from 'dingtalk-jsapi';
import supplierConfig from '@/config/supplier';
import { list, login } from '@/api/supplierApi';
import { Toast } from 'vant';
import pagination from '@/components/Pagination/index';

export default {
  name: 'supplierPcIndex',
  components: {
    pagination
  },
  data() {
    return {
      // 总条数
      total: 0,
      loading: false,
      searchData: {
        pageNum: 1,
        pageSize: 10,
        companyType: '',
        searchValue: ''
      },
      supplierList: [],
      companyTypeList: [],
      show: false
    };
  },
  created() {
    getDictDetail('racm_supplier_type').then((res) => {
      if (res.code === 200) {
        this.companyTypeList = res.data;
      }
    });
    //this.checkLogin();
    this.getList();
  },
  methods: {
    checkLogin() {
      let that = this;
      dd.ready(function () {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.util.domainStorage.getItem({
          name: supplierConfig.ddStorage.userId, // 存储信息的key值
          onSuccess: function (info) {
            if (!info || !info.value) {
              that.doLogin();
            }
          },
          onFail: function () {
            that.doLogin();
          }
        });
      });
    },
    doLogin() {
      dd.runtime.permission.requestAuthCode({
        corpId: 'ding279a0c72591f0c8d35c2f4657eb6378f',
        onSuccess: function (result) {
          login({ authCode: result.code }).then((response) => {
            if (response.code === 200) {
              dd.util.domainStorage.setItem({
                name: supplierConfig.ddStorage.userId, // 存储信息的key值
                value: response.data.userid // 存储信息的Value值
              });
              dd.util.domainStorage.setItem({
                name: supplierConfig.ddStorage.userName, // 存储信息的key值
                value: response.data.name // 存储信息的Value值
              });
            } else {
              Toast(response.msg);
            }
          });
        },
        onFail: function () {
          Toast('用户信息获取识别，请稍后再试');
        }
      });
    },
    jumpToDetail(row) {
      console.log(row);
      this.$router.push({ path: '/supplierPcDetail', query: { id: row.id } });
    },
    getList() {
      this.loading = true;
      let that = this;
      list(this.searchData).then((res) => {
        if (res.code === 200) {
          that.supplierList.length = 0;
          res.rows.forEach((item) => {
            if (item.companyType) {
              let companyTypeArr = [];
              let typeArr = item.companyType.split(',');
              typeArr.forEach((t) => {
                for (let i = 0; i < that.companyTypeList.length; i++) {
                  if (t === that.companyTypeList[i].dictValue) {
                    companyTypeArr.push(that.companyTypeList[i].dictLabel);
                    break;
                  }
                }
              });
              item.companyTypeArr = companyTypeArr;
            }
            that.supplierList.push(item);
          });
          this.total = res.total;
          this.loading = false;
        }
      });
    },
    searchChange() {
      this.reloadData();
    },
    typeClick(item) {
      item.active = !item.active;
      let arr = '';
      this.companyTypeList.forEach((item) => {
        if (item.active) {
          if (arr === '') {
            arr += item.dictValue;
          } else {
            arr += ',' + item.dictValue;
          }
        }
      });
      this.searchData.companyType = arr;
      this.$forceUpdate();
    },
    resetType() {
      this.companyTypeList.forEach((item) => {
        item.active = false;
      });
      this.searchData.companyType = '';
      this.$forceUpdate();
    },
    confirmType() {
      this.show = false;
      this.reloadData();
    },
    reloadData() {
      this.finished = false;
      this.searchData.pageNum = 1;
      this.supplierList = [];
      this.getList();
    }
  }
};
</script>

<style scoped>
@import '../../../assets/css/supplier/common.css';
@import '../../../assets/css/supplier/demo1.css';
@import '../../../assets/css/supplier/demo2.css';
.custom-width {
  max-width: 1200px;
  min-width: 800px;
  width: 100%;
  margin: 20px auto;
}
.head_bg {
  background-image: url('../../../assets/image/supplier/pc/bg1.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
/deep/ .el-select .el-input__inner {
  border: 0;
  border-radius: 50px;
  height: 32px;
  line-height: 32px;
  text-align: center;
}
/deep/ .el-select .el-input__icon {
  line-height: 32px;
}
/deep/ .el-table tr {
  cursor: pointer;
}
</style>
